export const PATHS = {
  HOME: '/',
  NEW: '/new',
  CONFIRM: '/confirm',
};
